<!--
  - Copyright (C) 2020. Archimedes Exhibitions GmbH,
  - Saarbrücker Str. 24, Berlin, Germany
  -
  - This file contains proprietary source code and confidential
  - information. Its contents may not be disclosed or distributed to
  - third parties unless prior specific permission by Archimedes
  - Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
  - to copies made in any form and using any medium. It applies to
  - partial as well as complete copies.
  -->

<template>
  <b-container class="py-4" fluid>
    <h1 class="mt-3">Welcome to BPTC-EMS</h1>
    Below is the Sandoz campus layout, marking the positions of the exhibits.<br>
    Refer to the adjoining names of the exhibits while navigating through the EMS.
    <div class="text-center map-wrapper mt-5">
      <img thumb id="map" src="./../assets/bptc_map.png" alt="bptc-map">
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style lang="scss" scoped>
  .map-wrapper {
    background: #f5f5f5;
    padding: 20px;
  }
  #map{
    max-height: 70vh;
    max-width: 70vw;
  }

</style>
